import US from "../PanelAssets/img/country-flags/US-flag.svg";
import DE from "../PanelAssets/img/country-flags/DE-flag.svg";
import TR from "../PanelAssets/img/flags/tr.png";
import SA from "../PanelAssets/img/flags/sa.png";

/**
 * Single source of truth for the languages offered in the UI.
 * `activeLabel` is shown next to the current language inside its own language.
 */
export const LANGUAGE_OPTIONS = [
  { code: "en", name: "English", short: "EN", flag: US, activeLabel: "Active" },
  { code: "de", name: "Deutsch", short: "DE", flag: DE, activeLabel: "Aktiv" },
  { code: "tr", name: "Türkçe", short: "TR", flag: TR, activeLabel: "Aktif" },
  { code: "ar", name: "العربية", short: "AR", flag: SA, activeLabel: "نشط" }
];

export const getLanguageOption = lng => {
  const code = String(lng || "en").split("-")[0];
  return LANGUAGE_OPTIONS.find(l => l.code === code) || LANGUAGE_OPTIONS[0];
};

export default LANGUAGE_OPTIONS;
